<template>
  <v-app-bar app color="primary">
    <v-col class="d-flex align-items-center" style="cursor: pointer" @click="$router.push('/')">
      <IconLogoWorkstateSmall />
      <v-toolbar-title style="font-weight: bold">WorkstateAI: Dynamic Knowledge Foundation Demo
      </v-toolbar-title>
    </v-col>

    <!-- Only show navbar buttons once user logs in -->
    <template v-if="auth.route === 'authenticated' && $route.path !== '/'">
      <v-btn to="/">Dashboard</v-btn>
      <!-- <v-btn v-if="isUserInAdminGroup" to="/upload-document-view">Upload</v-btn> -->
      <v-btn to="/all-documents-view">Documents</v-btn>
      <v-btn v-if="isUserInAdminGroup" to="/settings-view">Settings</v-btn>
    </template>
    <template v-if="auth.route === 'authenticated'">
      <MenuProfilePopup />
    </template>
  </v-app-bar>
</template>

<script setup lang="ts">
import { watch } from 'vue';
import { useAuthenticator } from '@aws-amplify/ui-vue';
import { useAdminCheck, isUserInAdminGroup } from '@/composables/adminGroupGuard';
import MenuProfilePopup from '@/components/menus/MenuProfilePopup.vue';
import IconLogoWorkstateSmall from '@/components/icons/logos/IconLogoWorkstateSmall.vue';

const auth = useAuthenticator();
const { checkAdminGroup } = useAdminCheck();

const appPrefix = import.meta.env.VITE_APP_PREFIX ?? "Ws-IDP";

// Watch for changes in auth state and recheck user groups
watch(() => auth.route, (newRoute) => {
  if (newRoute === 'authenticated') {
    checkAdminGroup();
  }
});
</script>

<style scoped></style>
